import React from 'react';
import { Code as RadixCode } from '@radix-ui/themes';
import type { RadixCodeProps } from '@/types/radix-ui';

/**
 * Code component - wrapper around Radix UI Code
 * Provides inline code formatting
 */
export type CodeProps = RadixCodeProps;

const Code: React.FC<CodeProps> = props => {
  return <RadixCode {...props} />;
};

Code.displayName = 'Code';

export { Code };
